module.exports = __webpack_public_path__ + "img/camera_grey.b6baf81a.svg";